export enum BookingStatus {
  not_payed = 'not_payed',
  payed = 'payed',
  approved = 'approved',
  cancelled = 'cancelled',
  removed_by_admin = 'removed_by_admin',
  completed = 'completed',
}
